import { MQ } from "../styles/breakpoints";
import { useMediaQuery } from "./useMediaQuery";

/**
 * Reports whether the primary pointing device is touch-based.
 *
 * Drives UI that doesn't apply on phones/tablets even when a keyboard
 * could technically attach — e.g., hiding the ⌘K and ? topbar buttons.
 * Keyboard-driven shortcuts still work; this just removes the visual
 * affordances that would otherwise clutter a touch screen.
 */
export function useIsTouch(): boolean {
  return useMediaQuery(MQ.touch);
}
